<template>
  <svg
    class="svg-icon-wrapper"
    :width="props.size"
    :height="props.size"
    aria-hidden="true"
    fill="currentColor"
  >
    <title>{{ props.title }}</title>
    <use :xlink:href="`#icon-${props.name}`" :fill="props.color" />
  </svg>
</template>
<!-- svg-icon-wrapper -->
<script lang="ts">
import { defineComponent } from "vue";
import "../assets/icons/index";
export default defineComponent({
  name: "SvgIcon",
  props: {
    name: {
      type: String,
      required: true,
      default: "avatar",
    },
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "#5686E1",
    },
    title: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    return {
      props,
    };
  },
});
</script>
